module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAQBAMAAAACH4lsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTCAgKB4jKB4jKCAhJx8jKB8jKR8iKR8jKB8jKR4jJh4iJx4iKSAgICAjKR8jKUH8o4oAAAAPdFJOUwAfn2A5v+/feK9QkI8QUGP48nkAAABnSURBVAjXY2BAArw2OgYQ1rL//7+DmRz/geAHiCX///v8//8dgCz9/1/9//8PALL+g1kJDAyMENZHMOubEJjFkP//f+Hz/x+ArHigIZr/FYAsf5B5/wVQTGYwB+pZALHYWtsW2UUMAFonPgNSNvEGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/clock1.png
// module id = uLSO
// module chunks = 0